import React, { useState } from "react";
import { AgruparByProp } from "../../../Helpers/Agrupaciones/AgruparByProp";
import { ArrayTotalizarByProp } from "../Actions/TotalizarProps";
import { GetKey } from "../Actions/GetContainer";
import request from "../../../Helpers/API";
import { GetMonthNameByNumber } from "../Helper/GetMonthNameByNumber";
import { formatoFecha } from "../Actions/ActionEstadoResultados";
import { useBox, useBoxFiltros } from "../Helper/useBox";
import { BoxFiltros } from "../Helper/BoxFiltros";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useEffect } from "react";
import { BoxFiltrosSC } from "../Helper/BoxFiltrosSC";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AgruparBySuc } from "../../../Helpers/Agrupaciones/AgruparBySuc";
import { TRMargen } from "./SemaforoMArgenes/TRMargen";
import Swal from "sweetalert2";
import { TRMargenConsolidado } from "./SemaforoMArgenes/TRMargenConsolidado";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { BoxFiltrosSC2 } from "../Helper/BoxFiltrosSC2";

export const MargenesBrutosScreen = () => {
    const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
    const history = useHistory();
    const onHome = () => {
        history.push("/Finanzas/Main");
    };
    const [boxstate, setBoxState] = useBox();
    const [state, setState] = useState({
        result: [{}],
        resultguias: [{}]
    });
    const [data, setData] = useState({});
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [titulo, setTitulo] = useState(
        `MARGEN BRUTO`
    );
    useEffect(() => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        boxstate.periodoinicio = storedState.periodoinicio || "1"
        boxstate.periodofin = storedState.periodofin || currentMonth
        boxstate.ejercicioinicio = storedState.ejercicio || currentYear
        setBoxState((prevState) => ({
            ...prevState,
            periodoinicio: storedState.periodoinicio || "1",
            periodofin: storedState.periodofin || currentMonth,
            ejercicio: storedState.ejercicio || "1",
            mesFin: storedState.periodofin || currentMonth
        }));
        BoxClick();
    }, []);

    // console.log(boxstate)

    const generarRangoMeses = (mesInicio, mesFin) => {
        const inicio = parseInt(mesInicio, 10);
        const fin = parseInt(mesFin, 10);

        if (isNaN(inicio) || isNaN(fin) || inicio < 1 || fin > 12 || inicio > fin)
            return "";

        return Array.from({ length: fin - inicio + 1 }, (_, i) => inicio + i).join(
            ", "
        );
    };

    const BoxClick = () => {
        return new Promise((res, req) => {
            if (boxstate.ejercicio == "0") {
                req("Favor de indicar el ejercicio");
                return;
            }
            if (boxstate.mesFin == "0") {
                req("Favor de indicar el periodo");
                return;
            }

            const periodo = generarRangoMeses(
                boxstate.periodoinicio,
                boxstate.periodofin
            );

            // console.log(periodo)
            setLoader({ ...loader, mostrar: true });

            request
                .get(
                    `FEMargenes/MargenesBrutos?ejercicio=${boxstate.ejercicioinicio}&periodo=${periodo}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setState({
                        ...state,
                        result: result.margenes,
                        resultguias: result.guias
                    });
                    if (String(boxstate.periodoinicio) === String(boxstate.periodofin)) {
                        setTitulo(
                            `MARGEN BRUTO ${GetMonthNameByNumber(
                                boxstate.periodoinicio
                            ).toUpperCase()} ${boxstate.ejercicioinicio
                            }`
                        );
                    }
                    else {
                        setTitulo(
                            `MARGEN BRUTO ${GetMonthNameByNumber(
                                boxstate.periodoinicio
                            ).toUpperCase()} - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejercicioinicio
                            }`
                        );
                    }

                })
                .catch((err) => {
                    setLoader({ ...loader, mostrar: false });
                    req(JSON.stringify(err));
                });
        });
    };

    const onGeneraExcel = () => {
        setLoader({ ...loader, mostrar: true });
        const periodo = generarRangoMeses(
            boxstate.periodoinicio,
            boxstate.periodofin
        );
        request
            .get(
                `FEMargenes/MargenesBrutosExcel?ejercicio=${boxstate.ejercicioinicio}&periodo=${periodo}`
            )
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };


    //   console.log(state)

    return (
        <PlantillaScreen
            titulo={titulo}
            className={"margenes-main-screen"}
            className_main={1}
        >
            <div id="margenes-container">
                <LoaderScreen loader={loader} />
                <div className="margenes-contenedor-filtros">
                    <div className="margenes-regresar" onClick={() => onHome()}>
                        <ArrowBackIcon /> Regresar
                    </div>
                    <BoxFiltrosSC2
                        onBoxChange={setBoxState}
                        boxState={boxstate}
                        BoxClick={BoxClick}
                        dmesinicio="none"
                        titulo_filtro="FILTRO"
                        titulo="SEMAFORO POR SUCURSAL Y LINEA DE PRODUCTOS"
                        subtitulo={titulo}
                    ></BoxFiltrosSC2>

                    <div className="margenes-excel" onClick={() => onGeneraExcel()}>
                        Excel
                    </div>
                </div>

                <div className="margenes-container-table">
                    <div className="container-table scroll-4">
                        <table cellSpacing={0} id="tabla-sticky">
                            <thead>
                                <tr>
                                    <td className="ta-center sticky-col-h-30"></td>
                                    <td><div className="ta-center sticky-col-guia-30">Guia</div></td>
                                    <td><div className="ta-center">Grupo</div></td>
                                    <td><div className="ta-center">Sinaloa</div></td>
                                    <td><div className="ta-center">Nayarit</div></td>
                                    <td><div className="ta-center">Navolato</div></td>
                                    <td><div className="ta-center">Eldorado</div></td>
                                    <td><div className="ta-center">La Cruz</div></td>
                                    <td><div className="ta-center">El Rosario</div></td>
                                    <td><div className="ta-center">Tepic</div></td>
                                    <td><div className="ta-center">Santiago</div></td>
                                    <td><div className="ta-center">Tecuala</div></td>
                                    <td><div className="ta-center">San José</div></td>
                                    <td><div className="ta-center">Caimanero</div></td>
                                    <td><div className="ta-center">Costa Rica</div></td>
                                    <td><div className="ta-center">Villa Union</div></td>
                                    <td><div className="ta-center">San Vicente</div></td>
                                </tr>
                                <tr style={{ height: "10px" }}></tr>
                            </thead>
                            <tbody>
                                <TRMargen
                                    linea={"Maquinaria"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "MAQUINARIA"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "MAQUINARIA"
                                    )}
                                />
                                <TRMargen
                                    linea={"Refacciones"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "REFACCIONES"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "REFACCIONES"
                                    )}
                                />
                                <TRMargen
                                    linea={"Servicio"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "SERVICIO"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "SERVICIO"
                                    )}
                                />
                                <TRMargen
                                    linea={"Productos aliados"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "PRODUCTOS ALIADOS"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "PRODUCTOS ALIADOS"
                                    )}
                                />
                                <TRMargen
                                    linea={"Ferreteria"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "FERRETERIA"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "FERRETERIA"
                                    )}
                                />
                                <TRMargen
                                    linea={"Sistemas de riego"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "SISTEMAS DE RIEGO"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "SISTEMAS DE RIEGO"
                                    )}
                                />
                                <TRMargen
                                    linea={"Ams"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "AMS"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "AMS"
                                    )}
                                />
                                <TRMargen
                                    linea={"Seminuevos"}
                                    data={state.result.filter(
                                        (element) => element.departamento === "USADOS"
                                    )}
                                    guia={state.resultguias.filter(
                                        (element) => element.departamento === "USADOS"
                                    )}
                                />
                                <TRMargenConsolidado linea={"Resumen"} data={state.result} guia={state.resultguias} />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
